import React from 'react'
import { useSelector } from 'react-redux'
import {Navigate,Outlet} from 'react-router-dom'

function LoginGate(props) {
    const auth = useSelector(state => state.login);     
    return (
        <>
            {auth.isLog ? <Outlet></Outlet> :<Navigate to={"/Login"} replace />}
        </>
    )
}

export default LoginGate